<sbw-layout [backButtonVisible]="false" [continueButtonVisible]="false" type="Amendment"
    [showPaddingAndBackground]="false" [hideDisclaimer]="true" [amendmentPage]="true">
    <div class="row uncollapse bookings-container">
        <sbw-active 
            *ngIf="ReservationStatus===status.Active" 
            [reservation]="reservation" 
            [printConfCallback]="printConfirmation"
            (loadingDone)="loadingDone()">
        </sbw-active>
        <sbw-inactive 
            *ngIf="ReservationStatus===status.Inactive || ReservationStatus===status.Preliminary" 
            [reservation]="reservation" 
            [printConfCallback]="printConfirmation"
            (loadingDone)="loadingDone()" 
            [errors]="errors">
        </sbw-inactive>
    </div>
</sbw-layout>
